import Base from "@/api/Base";

export const ACTION_ACCEPT = 'accept';
export const ACTION_SENDOFF = 'sendoff';
export const ACTION_REQUEST_VITA = 'request-vita';
export const ACTION_DECLINE_VITA = 'decline-vita';
export const ACTION_SEND_VITA = 'send-vita';
export const ACTION_MAKE_APPOINTMENT = 'make-appointment';
export const ACTION_CONFIRM_APPOINTMENT = 'confirm-appointment';
export const ACTION_APPOINTMENT_DATES_NOT_POSSIBLE = 'appointment-dates-not-possible';
export const ACTION_SUGGESTING_NEW_DATES = 'suggesting-new-dates';
export const ACTION_APPOINTMENT_DEFERRAL = 'appointment-deferral';
export const ACTION_MARK_AS_READ = 'mark-as-read';
export const ACTION_ALTERNATIVE_APPOINTMENT_POSSIBLE = 'alternative-appointment-possible';
export const ACTION_APPLICANT_WANTS_ALTERNATIVE_APPOINTMENT = 'applicant-wants-alternative-appointment';
export const ACTION_FOLLOW_UP_APPOINTMENT = 'follow-up-appointment';
export const ACTION_COLLABORATION = 'collaboration';
export const ACTION_COLLABORATION_ACCEPT = 'collaboration-accept';
export const ACTION_APPLICANT_INTERESTED_IN_COLLABORATION = 'applicant-interested-in-collaboration';
export const ACTION_APPLICANT_INTERESTED_IN_COLLABORATION_WANTS_TO_WAIT = 'applicant-interested-in-collaboration-wants-to-wait';

export default class Reply extends Base
{
	setMessageId (v)
	{
		this.messageId = v;
		return this;
	}

	setAction (v)
	{
		this.data.action = v;
		return this;
	}

	setCustomerUninterestingType (v)
	{
		this.data.customerUninterestingType = v;
		return this;
	}

	setMakeAppointmentData (v)
	{
		this.data.makeAppointmentData = v;
		return this;
	}

	setChosenDate (v)
	{
		this.data.chosenDate = v;
		return this;
	}

	setCounterProposalDates (v)
	{
		this.data.counterProposalDates = v;
		return this;
	}

	setSendVitaData (v)
	{
		this.data.sendVitaData = v;
		return this;
	}

	setApplicantSendOffData (v)
	{
		this.data.applicantSendOffData = v;
		return this;
	}

	setCustomerSendOffData (v)
	{
		this.data.customerSendOffData = v;
		return this;
	}

	setAppointmentDidNotTakePlaceData (v)
	{
		this.data.appointmentDidNotTakePlaceData = v;
		return this;
	}

	setCollaboration (v)
	{
		this.data.collaboration = v;
		return this;
	}

	getMethod ()
	{
		return 'PUT';
	}

	getUrl ()
	{
		return '/kommunikation/abstimmung/nachricht/' + this.messageId;
	}
}